import { useEffect, useState } from 'react'
import ReservationSidebar from '../Commun/ReservationSidebar'
import ReservationHeader from '../Commun/ReservationHeader'
import { useProperty } from '../../PropertyContext';
import { ReservationBookinglist } from '../../Services/Service';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const ReserBookingReport = () => {
    const { selectedProperty } = useProperty();
    const [loading, setLoading] = useState(false);
    const [bookingData, setBookingData] = useState([]);
    const [filters, setFilters] = useState({
        BookingDate: "",
        GuestName: "",
        CompanyName: "",
        CheckInDate: "",
        CheckOutDate: ""
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({
            ...prev,
            [name]: value
        }));
    };


    useEffect(() => {

        const fetchBookings = async () => {
            if (!selectedProperty?.PropertyID) return;

            setLoading(true);
            try {
                const data = await ReservationBookinglist({
                    propertyID: selectedProperty.PropertyID,
                    BookingDate: filters.BookingDate,
                    GuestName: filters.GuestName,
                    CheckInDate: filters.CheckInDate,
                    CheckOutDate: filters.CheckOutDate,
                });

                setBookingData(data || []);
            } catch (error) {
                console.log("Error fetching bookings", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBookings();

    }, [selectedProperty, filters]); // 👈 filters add kar diya

    const exportToExcel = () => {
        if (!bookingData || bookingData.length === 0) return;

        try {
            setLoading(true); // 🔵 Start loading

            const formattedData = bookingData.map((item, index) => {
                let email = "N/A";
                let mobile = "N/A";

                try {
                    const gd = JSON.parse(item.GuestDetails);
                    email = gd?.[0]?.EMailAddress || "N/A";
                    mobile = gd?.[0]?.MobileNumber || "N/A";
                } catch { }

                return {
                    "Sr#": index + 1,
                    "BON REF. Id": item.BONRESID,
                    "Conf. No": item.PMSRESID,
                    "Check-in": item.CheckInDate,
                    "Check-out": item.CheckOutDate,
                    "Guest Name": item.GuestName,
                    "Company": item.CompanyName,
                    "Email": email,
                    "Mobile No": mobile,
                    "Total Payment": item.TotalPayment,
                    "Payment Status": item.PaymentStatus,
                    "Booking Status": item.BookingStatus,
                    "Booking Date": item.BookingDate
                };
            });

            const worksheet = XLSX.utils.json_to_sheet(formattedData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Booking Report");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });

            const data = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
            });

            saveAs(data, "Booking_Report.xlsx");

        } catch (error) {
            console.error("Export Error:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}

            <div className="wrapper ">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />

                    <div className="container">
                        <div className="page-inner">

                            <div className="row">
                                <div className="col-md-12">

                                    <div className='card booking-filter-form'>
                                        <div className='card-body'>

                                            <form>
                                                <div className='d-flex gap-3'>

                                                    <div>
                                                        <label className='form-label'>Booking Date</label>
                                                        <input
                                                            className='form-control'
                                                            type='date'
                                                            name="BookingDate"
                                                            value={filters.BookingDate}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className='form-label'>Guest Name</label>
                                                        <input
                                                            className='form-control'
                                                            type='text'
                                                            name="GuestName"
                                                            value={filters.GuestName}
                                                            onChange={handleChange}
                                                            placeholder='Enter Guest name'
                                                        />
                                                    </div>

                                                     <div>
                                                        <label className='form-label'>Company  Name</label>
                                                        <input
                                                            className='form-control'
                                                            type='text'
                                                            
                                                            placeholder='Enter Company name'
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className='form-label'>Check-In</label>
                                                        <input
                                                            className='form-control'
                                                            type='date'
                                                            name="CheckInDate"
                                                            value={filters.CheckInDate}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className='form-label'>Check-Out</label>
                                                        <input
                                                            className='form-control'
                                                            type='date'
                                                            name="CheckOutDate"
                                                            value={filters.CheckOutDate}
                                                            onChange={handleChange}
                                                        />
                                                    </div>

                                                    <div className='text-end' style={{ marginTop: "27px" }}>
                                                        <button
                                                            className='btn btn-danger'
                                                            type='button'
                                                            onClick={() =>
                                                                setFilters({
                                                                    BookingDate: "",
                                                                    GuestName: "",
                                                                    CheckInDate: "",
                                                                    CheckOutDate: ""
                                                                })
                                                            }
                                                        >
                                                            Clear
                                                        </button>
                                                    </div>

                                                </div>
                                            </form>

                                        </div>
                                    </div>



                                    <div className="card">
                                        <div className="card-header">
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <h4 className="card-title">Booking Report</h4>
                                                <button className='btn btn-sm btn-primary' type="button" onClick={exportToExcel}>Export</button>
                                            </div>
                                        </div>
                                        {/* <div className="card-body">
                                            <div className="table-responsive">
                                                <table
                                                    className="display table  table-bordered table-striped table-hover basic-datatables"
                                                    style={{ width: '100%', tableLayout: 'fixed' }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "45px" }}>Sr#</th>
                                                            <th style={{ width: "110px" }} >BON REF. Id</th>
                                                            <th style={{ width: "150px" }}>Conf. No</th>
                                                            <th style={{ width: "95px" }}>Check-in</th>
                                                            <th style={{ width: "110px" }}>Check-out</th>
                                                            <th >Guest Info</th>
                                                            <th style={{ width: "8rem" }}>Moboile No</th>
                                                            <th style={{ width: "81px" }}>Payment </th>
                                                            <th style={{ width: "81px" }}>Status</th>
                                                            <th style={{ width: "95px" }}>Book On</th>

                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {bookingData.map((item, index) => (
                                                            <tr key={item.ID}>
                                                               
                                                                <td>{index + 1}</td>
                                                                <td>{item.BONRESID}</td>
                                                                <td>{item.PMSRESID}</td>
                                                                <td>{item.CheckInDate}</td>
                                                                <td> {item.CheckOutDate}</td>
                                                                <td>
                                                                    <b>{item.GuestName}</b>
                                                                    <div>{item.CompanyName}</div>
                                                                    <div>Email: {(() => {
                                                                        try {
                                                                            const gd = JSON.parse(item.GuestDetails);
                                                                            return gd?.[0]?.EMailAddress || "N/A";
                                                                        } catch {
                                                                            return "N/A";
                                                                        }
                                                                    })()}</div>
                                                                </td>
                                                                <td>
                                                                    {(() => {
                                                                        try {
                                                                            const gd = JSON.parse(item.GuestDetails);
                                                                            return gd?.[0]?.MobileNumber || "N/A";
                                                                        } catch {
                                                                            return "N/A";
                                                                        }
                                                                    })()}
                                                                </td>

                                                                <td>
                                                                    <div> <span > ₹ {item.TotalPayment} </span></div>
                                                                    <div>
                                                                        <span
                                                                            className={
                                                                                item.PaymentStatus === "Paid"
                                                                                    ? "text-success"
                                                                                    : item.PaymentStatus === "Pending"
                                                                                        ? "text-warning"
                                                                                        : "text-secondary"
                                                                            }
                                                                        >
                                                                            {item.PaymentStatus || "N/A"}
                                                                        </span>
                                                                    </div>
                                                                </td>

                                                                <td className="text-center">
                                                                    <span
                                                                        className={
                                                                            item.BookingStatus === "Confirmed"
                                                                                ? "text-success"
                                                                                : item.BookingStatus === "Pending"
                                                                                    ? "text-warning"
                                                                                    : item.BookingStatus === "Cancelled"
                                                                                        ? "text-danger"
                                                                                        : "text-secondary"
                                                                        }
                                                                    >
                                                                        {item.BookingStatus || "N/A"}
                                                                    </span>
                                                                </td>
                                                                <td>{item.BookingDate}</td>

                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div> */}
                                        <div className="card-body">
                                            <DataTable
                                                value={bookingData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                                stripedRows
                                                showGridlines
                                                responsiveLayout="scroll"
                                                emptyMessage="No bookings found."
                                                filterDisplay="menu"
                                            >

                                                {/* Sr No */}
                                                <Column
                                                    header="Sr#"
                                                    body={(rowData, { rowIndex }) => rowIndex + 1}

                                                />

                                                {/* BON Ref Id */}
                                                <Column
                                                    field="BONRESID"
                                                    header="BON REF. Id"
                                                    sortable
                                                    filter
                                                    filterPlaceholder="Search BON ID"
                                                />

                                                {/* Conf No */}
                                                <Column
                                                    field="PMSRESID"
                                                    header="Conf. No"
                                                    sortable
                                                    filter
                                                    filterPlaceholder="Search Conf No"
                                                />

                                                {/* Check In */}
                                                <Column
                                                    field="CheckInDate"
                                                    header="Check-in"
                                                    sortable
                                                    filter
                                                    dataType="date"
                                                />

                                                {/* Check Out */}
                                                <Column
                                                    field="CheckOutDate"
                                                    header="Check-out"
                                                    sortable
                                                    filter
                                                    dataType="date"
                                                />

                                                {/* Guest Name Filter */}
                                                <Column
                                                    field="GuestName"
                                                    header="Guest Name"
                                                    sortable
                                                    filter
                                                    filterPlaceholder="Search Guest"
                                                />

                                                {/* Mobile */}
                                                <Column
                                                    header="Mobile No"
                                                    filter
                                                    filterField="GuestDetails"
                                                    body={(rowData) => {
                                                        try {
                                                            const gd = JSON.parse(rowData.GuestDetails);
                                                            return gd?.[0]?.MobileNumber || "N/A";
                                                        } catch {
                                                            return "N/A";
                                                        }
                                                    }}
                                                />

                                                {/* Payment */}
                                                <Column
                                                    field="TotalPayment"
                                                    header="Payment"
                                                    sortable
                                                    filter
                                                    dataType="numeric"
                                                    body={(rowData) => (
                                                        <div>
                                                            <div>₹ {rowData.TotalPayment}</div>
                                                            <div
                                                                className={
                                                                    rowData.PaymentStatus === "Paid"
                                                                        ? "text-success"
                                                                        : rowData.PaymentStatus === "Pending"
                                                                            ? "text-warning"
                                                                            : "text-secondary"
                                                                }
                                                            >
                                                                {rowData.PaymentStatus || "N/A"}
                                                            </div>
                                                        </div>
                                                    )}
                                                />

                                                {/* Booking Status */}
                                                <Column
                                                    field="BookingStatus"
                                                    header="Status"
                                                    sortable
                                                    filter
                                                />

                                                {/* Booking Date */}
                                                <Column
                                                    field="BookingDate"
                                                    header="Book On"
                                                    sortable
                                                    filter
                                                    dataType="date"
                                                />

                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
